import { DAYS_OF_WEEK, TIME_SLOTS } from '../data';
import { cn } from '@/lib/utils';

export function TimeSlotsPicker({ selectedDays, timeSlots, onToggle }) {
  if (selectedDays.length === 0) return null;

  return (
    <div>
      <h2 className="text-base font-bold text-slate-900 sm:text-lg">
        What times work on each day?
      </h2>
      <p className="mt-1 text-sm text-slate-600">
        Pick at least one time slot per day.
      </p>
      <div className="mt-4 space-y-4">
        {DAYS_OF_WEEK.filter((d) => selectedDays.includes(d.value)).map(
          (day) => {
            const daySlots = timeSlots[day.value] ?? [];
            const isIncomplete = daySlots.length === 0;
            return (
              <div
                key={day.value}
                className={cn(
                  'rounded-2xl border-2 bg-white p-4 transition-colors',
                  isIncomplete
                    ? 'border-amber-200 bg-amber-50/40'
                    : 'border-slate-200'
                )}
              >
                <div className="flex items-baseline justify-between">
                  <h3 className="text-base font-bold text-slate-900">
                    {day.fullLabel}
                  </h3>
                  {isIncomplete && (
                    <span className="text-xs font-semibold text-amber-700">
                      Pick at least one time
                    </span>
                  )}
                </div>
                <div className="mt-3 grid grid-cols-2 gap-2 sm:grid-cols-4">
                  {TIME_SLOTS.map((slot) => {
                    const isActive = daySlots.includes(slot.value);
                    return (
                      <button
                        key={slot.value}
                        type="button"
                        onClick={() => onToggle(day.value, slot.value)}
                        aria-pressed={isActive}
                        className={cn(
                          'inline-flex cursor-pointer flex-col items-start gap-1 rounded-xl border-2 px-4 py-3 text-left transition-all',
                          isActive
                            ? 'border-brand-600 bg-brand-600 text-white shadow-md ring-2 ring-brand-200'
                            : 'border-slate-200 bg-white text-slate-800 hover:border-brand-300 hover:bg-slate-50'
                        )}
                      >
                        <span className="text-sm font-bold leading-tight">
                          {slot.label}
                        </span>
                        <span
                          className={cn(
                            'text-xs font-semibold leading-tight',
                            isActive ? 'text-white/85' : 'text-slate-600'
                          )}
                        >
                          {slot.range}
                        </span>
                      </button>
                    );
                  })}
                </div>
              </div>
            );
          }
        )}
      </div>
    </div>
  );
}